import React from 'react';
import POutlined from '@material-ui/icons/PhoneOutlined';

const PhoneOutlined = (props) => <POutlined {...props} />;

export default PhoneOutlined;
